import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { BookStyles } from './Style'
import { LightButton, SpaceBetween } from 'styles/GlobalStyle'
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { ReactComponent as LinesIcon } from 'assets/icons/Lines.svg';
import { SvgIcon } from '@mui/material';
import { AutoComplete, RenderFields } from 'components/Form';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { arrayPush, change } from 'redux-form';
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext';
import { chunk, map, partition } from 'lodash';
import { grades, visibleTypes } from 'keys';
import { getWordDefsFetch } from 'store/middlewares/words.crud';
import { queryClient as qc } from 'keys';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { splitArrayDynamically } from 'utils/array';
import DraftText from './DraftText';

const MultipleChoise = () => {
    const { categoryItem, question, currentItemIndex, setCurrentItemIndex } = useContext(CreateAssessmentDefContext)
    const { emptyItem, itemsKey } = categoryItem || {}
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)
    const pages = formValues?.[itemsKey] || []

    const params = useParams()
    const prevText = useRef(formValues?.pages)
    const { assessmentDefID } = params

    const [fontSize, setFontSize] = useState(null)
    const [textUpdated, setTextUpdated] = useState(null)
    const dispatch = useDispatch()

    const wordDefsData = useQuery({
        queryFn: [qc.wordDefs, assessmentDefID],
        queryFn: async ({ signal }) => {
            try {
                const { data } = await getWordDefsFetch({ signal, id: assessmentDefID });
                const [title, body] = partition(data.word_defs, word => word.word_def_fe_details?.is_title);

                let pages = splitArrayDynamically(body, "word_def_fe_details.new_page")
                if (pages.length % 2)
                    pages.push([])
                let groupedPages = chunk(pages, 2);
                groupedPages.unshift([title])
                let bookPages = []
                groupedPages.forEach(bookPage => {
                    let page = []
                    bookPage.forEach(singlePage => {
                        let text = ""
                        singlePage.forEach(word => {
                            text += word.word_def_text
                            if (word.word_def_fe_details?.break_line) {
                                text += "\n"
                            }
                            else text += " "
                        })
                        page.push(text)
                    });
                    bookPages.push(page)
                });
                dispatch(change('createAssessmentDef', `pages`, bookPages))
                console.log("bookPages", bookPages)
                return bookPages

            } catch (error) {
            }
            return [];
        },
        refetchOnWindowFocus: false,
        enabled: !!assessmentDefID
    })

    const goToPage = (index) => {
        setCurrentItemIndex(index)
    }

    const addBookPage = useCallback(() => {
        setCurrentItemIndex(currentItemIndex => currentItemIndex + 1)
        dispatch(arrayPush('createAssessmentDef', itemsKey, emptyItem))
    }, [categoryItem])

    useEffect(() => {
        dispatch(arrayPush('createAssessmentDef', itemsKey, ['']))
    }, [])

    // useEffect(() => {
    //     // if (textUpdated != null) {
    //     //     if (!textUpdated)
    //     if (!isEqual(prevText.current, formValues?.pages)) {
    //         prevText.current = formValues?.pages
    //         setTextUpdated(true)
    //     }
    //     // }
    //     // else {
    //     //     prevText.current = formValues?.pages
    //     //     setTextUpdated(false)
    //     // }
    // }, [formValues?.pages])

    let currentPage = currentItemIndex
    const gradesArray = map(grades, (obj, id) => ({
        id: obj.fontsize[visibleTypes.PARAGRAPH],
        name: obj.name
    }));

    return (
        <BookStyles fontSize={fontSize}>
            <div className='create-assessment-title'>

            </div>
            <div className='wrap-pages'>
                <div className='pages'>
                    {pages?.map((singlePage, pageIndex) => {
                        const cover = !pageIndex
                        return (
                            <div key={pageIndex} onClick={() => goToPage(pageIndex)}
                                className={`book-page ${pageIndex === currentItemIndex ? "selected-page" : ""}`}>
                                {singlePage.map((pa, index) =>
                                    <div
                                        className={`page ${index ? "single-book-page-left" : "single-book-page-right"} ${cover && 'cover-book'}`}
                                        key={question?.id}
                                    >
                                        {pa && !cover &&
                                            <div className='placeholder-lines'>
                                                <div className='placeholder-lines-icon'>
                                                    <SvgIcon fontSize='small' component={LinesIcon} inheritViewBox />
                                                </div>
                                            </div>
                                        }
                                        <div className='num-page'>
                                            {cover || `${pageIndex * 2 + index}`}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                    )}
                    <div>
                        <SpaceBetween />
                        <LightButton
                            variant="solid"
                            size="small"
                            label='הוספת עמוד'
                            action={addBookPage}
                            icon={<SvgIcon fontSize='small' component={AddIcon} inheritViewBox />}
                        />
                    </div>
                </div>
                <div className='select-font-size'>
                    <AutoComplete
                        placeholder={"בחר שכבה כדי לראות את גודל הפונט"}
                        options={gradesArray}
                        input={{
                            value: fontSize,
                            onChange: setFontSize
                        }}
                    />
                </div>
            </div>
            <div className='wrap-content'>
                <div className='content'>
                    {pages[currentPage]?.map((page, index) => {
                        const cover = pages[currentPage].length == 1
                        return (
                            <div key={index} className={`page-content ${cover && 'cover'}`}>
                                <div className={`wrap-number-page ${index && "right-page"}`}>
                                    <div className={`number-page`}>
                                        {(currentPage) * 2 + index + 1}
                                    </div>
                                </div>
                                <div className={`page-text ${cover && "cover-text"}`}>
                                    <RenderFields fields={[
                                        {
                                            name: `${itemsKey}[${currentPage}][${index}]`,
                                            component: "textarea",
                                            placeholder: cover ? "שם הסיפור" : "הכנס טקסט",
                                            className: `book-content-field ${cover && "cover-text"}`,
                                            fullHeight: !cover,
                                            textAlign: cover && "center"
                                        }
                                    ]} />
                                </div>
                            </div>)
                    })}
                </div>
                <div className='content draft-box'>
                    <DraftText />
                </div>
            </div>
        </BookStyles>
    )
}

export default MultipleChoise